export default __webpack_public_path__ + "static/media/supper_apps_m1.cbc1ab8b.png";